import { Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface DrawerButtonsProps {
  onSave: () => void;
  onCancel: () => void;
  disabled?: boolean;
}

export default function DrawerButtons({ onSave, onCancel, disabled = false }: DrawerButtonsProps) {
  const { t } = useTranslation(['common']);

  return (
    <Stack direction="row" justifyContent="flex-end" alignItems="baseline" spacing={2} sx={{ mb: 2 }}>
      <Button variant="secondary" onClick={onCancel}>
        {t('common:cancel')}
      </Button>
      <Button variant="primary" onClick={onSave} disabled={disabled}>
        {t('common:save')}
      </Button>
    </Stack>
  );
}
